import React from 'react';
import Header from './Header';
import Footer from './Footer';
import NewsBar from './NewsBar';
import TopBar from './TopBar';
import FlightTabs from './FlightTabs';
import { useAuth } from '../contexts/AuthContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isMultiFlightEnabled } = useAuth();
  return (
    <div className="flex flex-col min-h-screen bg-slate-900 text-slate-200">
      <TopBar />
      <Header />
      {isMultiFlightEnabled && <FlightTabs />}
      <NewsBar />
      <main className="flex-grow container mx-auto px-4 sm:px-6 py-4 flex flex-col">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
